module.exports = __webpack_public_path__ + "files/771ec2117ba107c0bf2dacafa25be069.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-bolditalic-webfont.eot
// module id = 387
// module chunks = 60